import { timeParse } from 'd3'

const assetLiquidityChartData = [
    {
        "dateString": "2010-12-31",
        "cash_as_pct_curr_assets_deviation": "",
        "cash_as_pct_curr_assets_h_deviation": "0.537956924",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2011-06-30",
        "cash_as_pct_curr_assets_deviation": "",
        "cash_as_pct_curr_assets_h_deviation": "0.709762749",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2011-12-31",
        "cash_as_pct_curr_assets_deviation": "",
        "cash_as_pct_curr_assets_h_deviation": "0.589970433",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2012-06-30",
        "cash_as_pct_curr_assets_deviation": "",
        "cash_as_pct_curr_assets_h_deviation": "-0.001059181",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2012-12-31",
        "cash_as_pct_curr_assets_deviation": "",
        "cash_as_pct_curr_assets_h_deviation": "0.131608551",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2013-06-30",
        "cash_as_pct_curr_assets_deviation": "-1.385487757",
        "cash_as_pct_curr_assets_h_deviation": "-0.022904102",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2013-12-31",
        "cash_as_pct_curr_assets_deviation": "0.403693951",
        "cash_as_pct_curr_assets_h_deviation": "0.461328057",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2014-06-30",
        "cash_as_pct_curr_assets_deviation": "-0.969360395",
        "cash_as_pct_curr_assets_h_deviation": "-0.064900994",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2014-12-31",
        "cash_as_pct_curr_assets_deviation": "0.749890298",
        "cash_as_pct_curr_assets_h_deviation": "0.407140329",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2015-06-30",
        "cash_as_pct_curr_assets_deviation": "0.469332501",
        "cash_as_pct_curr_assets_h_deviation": "0.342144168",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2015-12-31",
        "cash_as_pct_curr_assets_deviation": "-0.531892721",
        "cash_as_pct_curr_assets_h_deviation": "-0.096178497",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2016-06-30",
        "cash_as_pct_curr_assets_deviation": "-2.179455801",
        "cash_as_pct_curr_assets_h_deviation": "-0.42118096",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2016-12-31",
        "cash_as_pct_curr_assets_deviation": "0.615709144",
        "cash_as_pct_curr_assets_h_deviation": "0.262746869",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2017-06-30",
        "cash_as_pct_curr_assets_deviation": "-0.022946772",
        "cash_as_pct_curr_assets_h_deviation": "0.16668992",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2017-12-31",
        "cash_as_pct_curr_assets_deviation": "0.985586901",
        "cash_as_pct_curr_assets_h_deviation": "0.461239791",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2018-06-30",
        "cash_as_pct_curr_assets_deviation": "0.23395442",
        "cash_as_pct_curr_assets_h_deviation": "0.435830776",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2018-12-31",
        "cash_as_pct_curr_assets_deviation": "1.57219544",
        "cash_as_pct_curr_assets_h_deviation": "0.83419711",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2019-06-30",
        "cash_as_pct_curr_assets_deviation": "0.794971501",
        "cash_as_pct_curr_assets_h_deviation": "0.734916143",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2019-12-31",
        "cash_as_pct_curr_assets_deviation": "0.946521229",
        "cash_as_pct_curr_assets_h_deviation": "0.811171715",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    },
    {
        "dateString": "2020-06-30",
        "cash_as_pct_curr_assets_deviation": "0.724855678",
        "cash_as_pct_curr_assets_h_deviation": "0.737681398",
        "chart_name": "Asset Liquidity (Cash as a % of Current Assets)",
        "chart_number": "6"
    }
]

const parseDate = timeParse('%Y-%m-%d')

export default assetLiquidityChartData.map(d => {
  d['date'] = parseDate(d['dateString'])
  return d
})
